export default "__VITE_ASSET__aQsBZ5HR__"